var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatePulseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_32629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.125H1.125V15.75C1.125 16.0484 1.24353 16.3345 1.4545 16.5455C1.66548 16.7565 1.95163 16.875 2.25 16.875H16.875V15.75H2.25V1.125Z",
    fill: "#59647B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.0625H12.9375V6.1875H14.9569L10.6875 10.4569L8.27437 8.03813C8.22208 7.9854 8.15987 7.94356 8.09132 7.915C8.02278 7.88644 7.94926 7.87174 7.875 7.87174C7.80074 7.87174 7.72722 7.88644 7.65868 7.915C7.59013 7.94356 7.52792 7.9854 7.47563 8.03813L3.375 12.1444L4.16812 12.9375L7.875 9.23063L10.2881 11.6494C10.3404 11.7021 10.4026 11.7439 10.4712 11.7725C10.5397 11.8011 10.6132 11.8158 10.6875 11.8158C10.7618 11.8158 10.8353 11.8011 10.9038 11.7725C10.9724 11.7439 11.0346 11.7021 11.0869 11.6494L15.75 6.98062V9H16.875V5.0625Z",
    fill: "#59647B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_32629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatePulseIcon);
export default __webpack_public_path__ + "static/media/ratePulseIcon.0e5a2157c2c89d0e1f8752d89905a17b.svg";
export { ForwardRef as ReactComponent };